var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDropDownPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15367_15097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 26,
    height: 26,
    transform: "rotate(-180 26 26)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15367_15097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5204 10.6445L16.9343 14.0581C16.9812 14.1052 17.0182 14.1578 17.0453 14.216C17.0724 14.2739 17.0859 14.3361 17.0859 14.4026C17.0859 14.5353 17.0411 14.6507 16.9513 14.7487C16.8616 14.8466 16.7433 14.8955 16.5965 14.8955L9.40483 14.8955C9.25804 14.8955 9.13978 14.846 9.05004 14.7471C8.96031 14.6483 8.91544 14.533 8.91544 14.4012C8.91544 14.3682 8.96608 14.2538 9.06738 14.0581L12.481 10.6445C12.5593 10.566 12.6404 10.5086 12.7242 10.4725C12.8079 10.4364 12.9001 10.4184 13.0007 10.4184C13.1013 10.4184 13.1934 10.4364 13.2772 10.4725C13.361 10.5086 13.4421 10.566 13.5204 10.6445Z",
    fill: "#E6E6E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDownPortfolio);
export default __webpack_public_path__ + "static/media/arrow_drop_down_portfolio.24ff77467de4088af1b91798aafc34dc.svg";
export { ForwardRef as ReactComponent };